import { render, staticRenderFns } from "./GroupDialog.vue?vue&type=template&id=f291e5d0"
import script from "./GroupDialog.vue?vue&type=script&lang=js"
export * from "./GroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports